import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {ApiService, RagTemplateDef} from "../../../services/api.service";
import {QuickDashboardComponent} from "../../../core/quick-dashboard/quick-dashboard.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {RouterLink} from "@angular/router";
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {PreviewButtonComponent} from "../../../core/preview-button/preview-button.component";
import {UserIdTagComponent} from "../../users/user-id-tag/user-id-tag.component";
import {ChatbotUidTagComponent} from "../../chatbots/chatbot-uid-tag/chatbot-uid-tag.component";
import {NgClass, NgIf} from "@angular/common";
import {AuthService} from "../../../auth/services/auth.service";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'templating-list',
  standalone: true,
  imports: [
    QuickDashboardComponent,
    ManageButtonComponent,
    RouterLink,
    DeleteButtonComponent,
    PreviewButtonComponent,
    UserIdTagComponent,
    ChatbotUidTagComponent,
    NgIf,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    NgClass,
  ],
  templateUrl: './templating-list.component.html'
})
export class TemplatingListComponent implements OnInit {

  readonly now = new Date()
  loader?: Observable<RagTemplateDef[]>
  results: RagTemplateDef[] = []
  roleCheckFailed = false
  currentUser?: string

  constructor(
    readonly auth: AuthService,
    readonly api: ApiService,
  ) {
    this.roleCheckFailed = !this.auth.hasRoleInRange(['Super', 'Admin'])
  }

  ngOnInit(): void {
    this.loader = this.api.getTemplates()
    this.currentUser = this.auth.getSessionUserId()
  }

  onLoadComplete(results: RagTemplateDef[]) {
    this.results = results
  }
}
